module.exports = "<div class=\"input-append datepicker-input\">\n \t<input type=\"text\"\n \t\tclass=\"text medium-field\" ng-model=\"dt\" rc-datepicker-inner min-date=\"minDate\" opened=\"opened\"\n \t/>\n\t<button class=\"btn btn-default\" ng-click=\"toggle()\">\n\t\t<span class=\"aui-icon aui-icon-small aui-iconfont-calendar\"></span>\n\t</button>\n\n</div>";


//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/views/datepicker.html
// module id = 308
// module chunks = 0